import { InvoiceSignatureType, ProjectSignatureType } from 'src/api';

export const signatureTypeEnumToString = (signatureType: number): string => {
    switch (signatureType) {
        case InvoiceSignatureType.NUMBER_1:
        case ProjectSignatureType.NUMBER_1:
            return 'Customer Authorization';
        case InvoiceSignatureType.NUMBER_2:
        case ProjectSignatureType.NUMBER_2:
            return 'Customer Acknowledgement';
        case InvoiceSignatureType.NUMBER_3:
        case ProjectSignatureType.NUMBER_3:
            return 'Notice of the Three-Day Right to Cancel';
        case InvoiceSignatureType.NUMBER_4:
            return 'Invoice Changes';
        default:
            return '';
    }
};
